<div class="chat" [class.chat--sidebar-closed]="!sidebarOpen"
     (click)="onPageClick($event)" (keydown.escape)="onEscape()">
  <div class="chat__backdrop" *ngIf="sidebarOpen" (click)="toggleSidebar(false)"></div>
  <app-chat-sidebar class="chat__sidebar"
                    [attr.inert]="sidebarOpen ? null : ''"
                    [threads]="threads"
                    [activeThread]="threadId"
                    [hasMore]="chatState.hasMoreThreads"
                    [loading]="chatState.loadingThreads"
                    [failed]="chatState.threadsFailed"
                    (retry)="chatState.loadThreads()"
                    (navigated)="onNavigated()"
                    (rename)="renameThread($event)"
                    (remove)="deleteThread($event)"
                    (loadMore)="chatState.loadMoreThreads()"
                    (closed)="toggleSidebar(false)"></app-chat-sidebar>

  <main class="chat__main">
    <header class="chat__header">
      <ng-container *ngIf="!sidebarOpen">
        <button type="button" class="chat__icon-button chat__open-sidebar" (click)="toggleSidebar(true)"
                aria-label="Open sidebar" title="Open sidebar">
          <svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="3.5" width="15" height="13" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M7.5 3.5v13" stroke="currentColor" stroke-width="1.5"/></svg>
        </button>
        <a [routerLink]="['/chat']" class="chat__icon-button chat__new" (click)="onNavigated()"
           aria-label="New chat" title="New chat">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4.5v11M4.5 10h11" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>
        </a>
      </ng-container>
      <h1 class="chat__title" *ngIf="threadId" [title]="title">{{ title }}</h1>
    </header>

    <div class="chat__problem" *ngIf="problem" role="alert">
      <span>{{ problem }}</span>
      <button type="button" class="chat__problem-dismiss" (click)="problem = null" aria-label="Dismiss">
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5.5 5.5l9 9M14.5 5.5l-9 9" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg>
      </button>
    </div>

    <!-- A chat not yet started: the question box in the middle of the page -->
    <section class="chat__welcome" *ngIf="!threadId">
      <div class="chat__welcome-inner">
        <h1 class="chat__greeting">{{ greeting }}</h1>
        <app-chat-composer placeholder="Ask about employment law in any country"
                           [text]="draft" (textChange)="setDraft($event)"
                           (send)="ask($event)"></app-chat-composer>
        <ul class="chat__suggestions" *ngIf="suggestions.length" aria-label="Questions you could ask">
          <li *ngFor="let suggestion of suggestions">
            <button type="button" class="chat__suggestion" (click)="ask(suggestion)">{{ suggestion }}</button>
          </li>
        </ul>
        <p class="chat__disclaimer">
          GPS AI answers from Global People Strategist content and can make mistakes.
          Always check an answer against the references it cites.
        </p>
      </div>
    </section>

    <ng-container *ngIf="threadId">
      <div class="chat__scroller" #scroller (scroll)="onScroll()"
           (mouseover)="onAnswerMouseOver($event)" (mouseout)="onAnswerMouseOut($event)">
        <div class="chat__status" *ngIf="loading" role="status">
          <span class="chat__thinking" aria-hidden="true"></span>
          <span class="chat__visually-hidden">Loading chat</span>
        </div>
        <div class="chat__status chat__unavailable" *ngIf="unavailable" role="alert">
          <p>This chat could not be opened. It may have been deleted.</p>
          <a [routerLink]="['/chat']" class="chat__start-new">Start a new chat</a>
        </div>
        <div class="chat__column" *ngIf="conversation">
          <article class="turn" *ngFor="let turn of conversation.turns; let last = last" [class.turn--last]="last">
            <div class="turn__question">{{ turn.question }}</div>
            <div class="turn__answer" [attr.aria-busy]="!turn.complete">
              <div class="turn__waiting" *ngIf="turn.waiting" role="status">
                <span class="chat__thinking" aria-hidden="true"></span>
                <span class="chat__visually-hidden">GPS AI is working on an answer</span>
              </div>
              <div class="answer" [class.answer--failed]="turn.failed" [innerHTML]="turn.html"></div>
              <div class="turn__actions" *ngIf="turn.complete && !turn.failed">
                <button type="button" class="turn__copy" (click)="copy(turn)" title="Copy answer">
                  <svg viewBox="0 0 20 20" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M13 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>
                  <span aria-live="polite">{{ copied === turn ? 'Copied' : 'Copy' }}</span>
                </button>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div class="chat__dock" *ngIf="!unavailable">
        <button type="button" class="chat__to-end" *ngIf="awayFromEnd" (click)="scrollToEnd(true)"
                aria-label="Scroll to the end" title="Scroll to the end">
          <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v11.5M10 15.5l-5-5M10 15.5l5-5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <div class="chat__dock-inner">
          <app-chat-composer placeholder="Ask a follow-up question"
                             [busy]="loading || !!conversation?.answering"
                             [text]="draft" (textChange)="setDraft($event)"
                             (send)="ask($event)"></app-chat-composer>
          <p class="chat__disclaimer">
            GPS AI can make mistakes. Always check an answer against the references it cites.
          </p>
        </div>
      </div>
    </ng-container>
  </main>
</div>
